<template><div><h1>VUX V2.3.4 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] 支持遮罩点击事件 on-click-mask #1496</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 初始化时不触发 on-change 事件</li>
</ul>
<h2><a href="/zh-CN/components/inline-loading.html">InlineLoading</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复只有两个轮播图且为 loop 时点击失效问题 #1484 @unclay</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.4-232.vue?be46a858